import { render } from "./LoadingFull.vue?vue&type=template&id=fa6a9370&scoped=true"
const script = {}

import "./LoadingFull.vue?vue&type=style&index=0&id=fa6a9370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6a9370"]])

export default __exports__